"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var stimulus_1 = require("stimulus");
var LOADING_TEXT = '読み込み中...';
var ParentNavigationMoreController = /** @class */ (function (_super) {
    __extends(ParentNavigationMoreController, _super);
    function ParentNavigationMoreController() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ParentNavigationMoreController.prototype.loadMore = function (e) {
        var _this = this;
        var _a;
        e.preventDefault();
        if (!this.hasInitialListTarget || !this.hasLoadMoreButtonTarget) {
            return;
        }
        var btn = this.loadMoreButtonTarget;
        var listEl = this.initialListTarget;
        var nextOffsetAttr = btn.getAttribute('data-next-offset');
        var url = btn.getAttribute('data-more-url');
        if (!url) {
            return;
        }
        var originalText = (_a = btn.textContent) !== null && _a !== void 0 ? _a : '';
        btn.disabled = true;
        btn.textContent = LOADING_TEXT;
        var requestUrl = new URL(url, window.location.origin);
        if (nextOffsetAttr) {
            requestUrl.searchParams.set('offset', nextOffsetAttr);
        }
        fetch(requestUrl.toString(), { method: 'GET', headers: { Accept: 'application/json' } })
            .then(function (res) {
            if (!res.ok) {
                throw new Error("HTTP ".concat(res.status));
            }
            return res.json();
        })
            .then(function (data) {
            var _a;
            var items = (_a = data === null || data === void 0 ? void 0 : data.items) !== null && _a !== void 0 ? _a : [];
            var hasMore = (data === null || data === void 0 ? void 0 : data.has_more) === true;
            items.forEach(function (item) {
                listEl.appendChild(_this.buildListItem(item));
            });
            if (!hasMore) {
                btn.style.display = 'none';
            }
            else {
                var currentOffset = parseInt(nextOffsetAttr !== null && nextOffsetAttr !== void 0 ? nextOffsetAttr : '0', 10) || 0;
                btn.setAttribute('data-next-offset', String(currentOffset + items.length));
                btn.disabled = false;
                btn.textContent = originalText;
            }
        })
            .catch(function () {
            btn.disabled = false;
            btn.textContent = originalText;
        });
    };
    ParentNavigationMoreController.prototype.buildListItem = function (item) {
        var li = document.createElement('li');
        li.className = item.active ? 'cat-item' : 'cat-item cat-item-inactive';
        if (item.active) {
            li.setAttribute('data-controller', 'tooltip');
            li.setAttribute('data-tooltip-toggle-class', 'cat-item-marker-tooltip-visible');
            var link = document.createElement('a');
            link.href = item.link;
            var wrapper = document.createElement('div');
            wrapper.className = 'cat-item-marker-wrapper';
            wrapper.appendChild(document.createTextNode(item.title));
            if (item.marked) {
                var marker = document.createElement('div');
                marker.className = 'cat-item-marker';
                marker.setAttribute('data-target', 'tooltip.trigger');
                wrapper.appendChild(marker);
            }
            link.appendChild(wrapper);
            li.appendChild(link);
            if (item.marker_tooltip_text) {
                var tooltip = document.createElement('span');
                tooltip.className = 'cat-item-marker-tooltip';
                tooltip.setAttribute('data-target', 'tooltip.tooltip');
                tooltip.textContent = item.marker_tooltip_text;
                li.appendChild(tooltip);
            }
        }
        else {
            var span = document.createElement('span');
            span.textContent = item.title;
            li.appendChild(span);
        }
        return li;
    };
    ParentNavigationMoreController.targets = ['initialList', 'loadMoreButton'];
    return ParentNavigationMoreController;
}(stimulus_1.Controller));
exports.default = ParentNavigationMoreController;
